import { render, staticRenderFns } from "./MyInputImage.vue?vue&type=template&id=45c9cbbe&scoped=true&"
import script from "./MyInputImage.vue?vue&type=script&lang=js&"
export * from "./MyInputImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c9cbbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c9cbbe')) {
      api.createRecord('45c9cbbe', component.options)
    } else {
      api.reload('45c9cbbe', component.options)
    }
    module.hot.accept("./MyInputImage.vue?vue&type=template&id=45c9cbbe&scoped=true&", function () {
      api.rerender('45c9cbbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyInputImage.vue"
export default component.exports